<div class="relative mx-auto h-full w-full overflow-hidden rounded-md">
  <img
    #avatar
    [src]="data().img"
    alt="Foto del piloto"
    class="aspect-square h-full w-full rounded-md object-cover"
    [ngClass]="maxWidth()"
    loading="lazy"
    onerror="this.src='https://secure.gravatar.com/avatar/f7219bbd71f453e41750fa3c63a11da1?size=64&default=mm'" />

  @let scoreValue = data().score ?? 0;

  @if (data().isFrame) {
    @if (scoreValue > 0) {
      <div
        class="absolute top-0 right-0 h-1 bg-current"
        [ngStyle]="{
          width: getSegmentWidth(scoreValue, 0),
          color: getBorderColor(scoreValue),
          boxShadow: getShadowColor(scoreValue)
        }"></div>
    }

    @if (scoreValue > 25) {
      <div
        class="absolute top-0 left-0 w-1 bg-current"
        [ngStyle]="{
          height: getSegmentHeight(scoreValue, 25),
          color: getBorderColor(scoreValue),
          boxShadow: getShadowColor(scoreValue)
        }"></div>
    }

    @if (scoreValue > 50) {
      <div
        class="absolute bottom-0 left-0 h-1 bg-current"
        [ngStyle]="{
          width: getSegmentWidth(scoreValue, 50),
          color: getBorderColor(scoreValue),
          boxShadow: getShadowColor(scoreValue)
        }"></div>
    }

    @if (scoreValue > 75) {
      <div
        class="absolute right-0 bottom-0 w-1 bg-current"
        [ngStyle]="{
          height: getSegmentHeight(scoreValue, 75),
          color: getBorderColor(scoreValue),
          boxShadow: getShadowColor(scoreValue)
        }"></div>
    }

    <div
      class="absolute z-10 rounded-md px-2 py-1 text-xs font-semibold text-white"
      [ngStyle]="getScoreBubbleStyle(score())">
      {{ score() }}%
    </div>
  }
</div>
